import { Component, OnInit } from '@angular/core';
import {
  ProviderName,
  FitnessTrackerService,
  InputField,
  InputType,
  config,
  FitnessTracker,
} from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-fitness-tracker-card',
  templateUrl: './fitness-tracker-card.component.html',
  styleUrl: './fitness-tracker-card.component.scss',
})
export class FitnessTrackerCardComponent implements OnInit {
  fitnessTrackersList$: Observable<FitnessTracker[]>;
  cardSubheading: string;
  providers = ProviderName;

  constructor(private fitnessTrackerService: FitnessTrackerService) { }

  ngOnInit(): void {
    this.fitnessTrackersList$ =
      this.fitnessTrackerService.getConnectedProvider();
  }

  connectFitnessTracker(providerName: ProviderName): void {
    const loginUrlParameters = this.generateLoginParameters(providerName);

    this.fitnessTrackerService.externalConnectionToProvider(
      providerName,
      loginUrlParameters
    );
  }

  /**
   * Generate default parameters required by every provider.
   */
  generateLoginParameters(providerName: ProviderName): InputField[] {
    return [
      {
        FieldName: 'State',
        Value: 'test',
        InputType: InputType.Text,
        Active: true,
        ErrorMessage: '',
      },
      {
        FieldName: 'redirectUrl',
        Value: `${config.portalUrl}/provider/${providerName}/connect-callback`,
        InputType: InputType.Text,
        Active: true,
        ErrorMessage: '',
      },
    ];
  }

  removeFitnessTracker(providerName: ProviderName): void {
    this.fitnessTrackerService.externalRevokeToProvider(providerName);
  }
}